var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73107 0C2.63134 -1.74385e-08 2.5316 0.0371234 2.45524 0.110613L0.114541 2.38348C-0.0381804 2.53122 -0.0381805 2.77138 0.114541 2.91912C0.266484 3.06762 0.512709 3.06686 0.665431 2.91988L2.73107 0.914451L4.7897 2.9123C4.94164 3.05928 5.18787 3.06004 5.34059 2.91155C5.49253 2.76305 5.49253 2.52364 5.34059 2.37591L3.00691 0.110613C2.93055 0.0371235 2.83081 1.74385e-08 2.73107 0Z",
    fill: "#2D3748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76893 9.84022C2.86866 9.84022 2.9684 9.7993 3.04476 9.71829L5.38546 7.21297C5.53818 7.05013 5.53818 6.7854 5.38546 6.62255C5.23352 6.45887 4.98729 6.4597 4.83457 6.62172L2.76893 8.83224L0.710301 6.63007C0.558358 6.46806 0.312133 6.46722 0.159411 6.6309C0.0074686 6.79458 0.00746858 7.05848 0.159411 7.22132L2.49309 9.71829C2.56945 9.7993 2.66919 9.84022 2.76893 9.84022Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.a46b5904c530afae5940f6bc4410c4c9.svg";
export { ForwardRef as ReactComponent };